import { Cookies } from 'react-cookie';

import { User } from './type';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getProfile = async () => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get('/me/', {
    headers: {
      Authorization: token,
    },
  });

  return data.data as User;
};
